import { getAirportNames } from '../../data/models/funnelOrder/airport'
import { getPlaceholder as getDestPlaceholder } from '../../data/models/funnelOrder/destination'
import { getPlaceholder } from '../../data/models/funnelOrder/roomType'
import { getThemeId } from '../../data/models/funnelOrder/theme'
import { getValueForOutgoingTime } from '../../data/models/funnelOrder/times'
import { getSiteCurrencyISO, SiteCurrency } from '../../data/models/locale'
import { AppState } from '../../data/state'
import { store } from '../../store/store'
import { DateFormatType, format } from '../../utils/date'
import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'
import { IFunnelTrackingData } from './models/IFunnelTrackingData'
import { IGoogleData } from './models/IGoogleData'
import { getExtras, getIdentityTrackingDetails } from './utils'

export function sentPaymentComplete(transactionId?: string) {
  try {
    const metrics = getMetrics()
    metrics.api.identify(getIdentityTrackingDetails())
    metrics.api.track(EventTypes.PURCHASE, getPaymentComplete(transactionId))
  } catch (e) {
    console.error(`Metrics failed becase: ${e}`)
  }
}

function getPaymentComplete(transactionId?: string): IFunnelTrackingData {
  const state: AppState = Object.assign({}, store.getState())
  const { funnelOrder } = state

  const crossSellItems = getExtras(funnelOrder)

  return {
    transaction_id: transactionId,
    total_value: funnelOrder.total,
    currency: getSiteCurrencyISO(state.locale.currency || SiteCurrency.euro),
    country: state.locale.country,
    trip_id: getThemeId(funnelOrder.theme),
    trip_type: 'City Break',
    category: 'trips',
    departure_airport: getAirportNames(
      funnelOrder.airports,
      state.locale.country,
    ),
    departure_time: getValueForOutgoingTime(funnelOrder.outgoingTime),
    departure_date: format(
      new Date(funnelOrder.departureDate!),
      DateFormatType.apidate,
    ),
    people:
      funnelOrder.numberOfAdults +
      funnelOrder.numberOfChildren +
      funnelOrder.numberOfBabies,
    adults: funnelOrder.numberOfAdults,
    children: funnelOrder.numberOfChildren,
    babies: funnelOrder.numberOfBabies,
    destination: getDestPlaceholder(funnelOrder.destination),
    accomodation: getPlaceholder(funnelOrder.roomType),
    days: funnelOrder.days,
    coupon: funnelOrder.discountCode
      ? funnelOrder.discountCode.code
      : undefined,
    giftcards: funnelOrder.giftcards.map(giftcard => ({
      code: giftcard.code,
      amount: giftcard.amount,
      isMarketing: giftcard.isMarketing,
    })),
    name_head_booker: funnelOrder.travelers[0].KnownAs,
    email_head_booker: funnelOrder.travelers[0].Email,
    date_of_birth_head_booker: format(
      funnelOrder.travelers[0].DateOfBirth!,
      DateFormatType.apidate,
    ),
    extras: crossSellItems.map((x: any) => x.name).join(', '),
    items: crossSellItems,
    is_member_get_member: state.memberGetMember.name !== '',
  }
}

export function FacebookPurchase(data: IFunnelTrackingData): any {
  return {
    value: data.total_value.toFixed(2),
    currency: data.currency,
    content_id: data.trip_id,
    content_name: data.trip_type,
    content_category: data.category,
    trip_type: data.trip_type,
    departure_date: data.departure_date,
    people: data.people,
    adults: data.adults,
    children: data.children,
    babies: data.babies,
    destination: data.destination,
    departure_airport: data.departure_airport,
    departure_time: data.departure_time,
    accomodation: data.accomodation,
    days: data.days,
    extras: data.extras,
    country: data.country,
    coupon: data.coupon,
  }
}

export function GooglePurchase(data: IFunnelTrackingData): any {
  const gData: IGoogleData = {
    transaction_id: data.transaction_id,
    value: data.total_value,
    currency: data.currency,
    coupon: data.coupon,
    items: [
      {
        id: data.trip_id,
        name: data.trip_type,
        category: data.category,
        price: data.total_value,
        quantity: 1,
        dimension1: data.trip_type,
        dimension2: data.departure_date,
        dimension3: data.people,
        dimension6: data.adults,
        dimension7: data.children,
        dimension8: data.babies,
        dimension9: data.destination,
        dimension10: data.departure_airport,
        dimension11: data.departure_time,
        dimension12: data.accomodation,
        dimension13: data.days,
        dimension14: data.extras,
        dimension15: data.date_of_birth_head_booker,
        dimension17: data.country,
        dimension18: data.coupon,
      },
    ],
  }
  if (data.items) {
    gData.items.push(...data.items)
  }
  return gData
}

export function SnapchatPurchase(data: IFunnelTrackingData): any {
  return {
    price: data.total_value,
    currency: data.currency,
    transaction_id: data.transaction_id,
    item_ids: [data.trip_id],
    item_category: data.category,
  }
}

export function AdWordsPurchase(data: IFunnelTrackingData): any {
  return {
    sendTo: 'N34OCMn0g3AQ-fm5zAM',
    value: data.total_value,
    currency: data.currency,
  }
}

export function BingPurchase(data: IFunnelTrackingData): any {
  return {
    event_category: 'purchase',
    event_action: 'purchase',
    event_label: 'trip',
    event_value: data.total_value,
  }
}

export function MemberGetMemberPurchase(data: IFunnelTrackingData): any {
  const giftcard = data.giftcards
    ? data.giftcards.find(x => x.isMarketing === true)
    : undefined
  return {
    is_member_get_member: data.is_member_get_member,
    email: data.email_head_booker,
    voucher: giftcard ? giftcard.code : undefined,
    name: data.name_head_booker,
    amount: data.total_value,
    order_id: data.transaction_id,
  }
}
